import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import { getMoviesMatchingTitle } from "../../firebase/moviedb";
import { uploadRecommendation } from "../../firebase/service";
import { HonkMovie, MovieDBType } from "../../types/Movie";
import { User } from "../../types/User";
import MovieMatch from "./movie_match";
import "./new_movie_modal.scss";

type NewMovieModalProps = {
  currentUser: User;
  closeModal: () => void;
};
const NewMovieModal: React.FC<NewMovieModalProps> = ({
  currentUser,
  closeModal,
}) => {
  const [movieTitle, setMovieTitle] = useState<string>("");
  const [shownMatches, setShownMatches] = useState<MovieDBType[]>();
  const [selectedMovie, setSelectedMovie] = useState<MovieDBType>();
  const [movieComment, setMovieComment] = useState<string>("");

  let searchTimeout: NodeJS.Timeout;

  const submitMovie = () => {
    if (currentUser && selectedMovie) {
      const movie: HonkMovie = {
        ...selectedMovie,
        comment: movieComment,
        recommendedBy: currentUser.displayName,
        likedBy: [currentUser.uid],
        watched: false,
      };
      uploadRecommendation(movie);
      closeModal();
    }
  };

  const fetchMatchingMovies = (searchString: string) => {
    getMoviesMatchingTitle(searchString).then((matches) => {
      setShownMatches(matches.slice(0, 10));
    });
  };

  const onMovieTitleChange = (searchString: string) => {
    clearTimeout(searchTimeout);
    if (searchString !== movieTitle) {
      setSelectedMovie(undefined);
      setMovieTitle(searchString);
      searchTimeout = setTimeout(() => fetchMatchingMovies(searchString), 1000);
    }
  };

  return (
    <div className="new-movie-modal-wrapper">
      <div onClick={closeModal} className={"opacity-layer"} />
      <div className={"modal-contents"}>
        <div className={"modal-header"}>Add Movie to Watch List</div>
        <input
          value={movieTitle}
          onChange={(e) => onMovieTitleChange(e.target.value)}
          className={"title input"}
          placeholder="title"
        />
        {selectedMovie ? (
          <MovieMatch
            onMovieSelected={() => void 0}
            movieMatch={selectedMovie}
          />
        ) : (
          shownMatches && (
            <div className={"movie-matches-section"}>
              <Scrollbars height={"50vh"}>
                <div className={"movie-matches"}>
                  {shownMatches.map((movie) => (
                    <MovieMatch
                      onMovieSelected={setSelectedMovie}
                      key={movie.id}
                      movieMatch={movie}
                    />
                  ))}
                </div>
              </Scrollbars>
            </div>
          )
        )}

        <input
          value={movieComment}
          onChange={(e) => setMovieComment(e.target.value)}
          className={"comment input"}
          placeholder="comment"
        />
        <button onClick={submitMovie} className={"create-btn"}>
          Add
        </button>
      </div>
    </div>
  );
};
export default NewMovieModal;
